import { Typography } from "@mui/material";
import moment from "moment";

import { RowSecretType } from "../../TableBody";

export default function CreationDate({ createdAt }: RowSecretType) {
	return (
		<Typography variant='subtitle2'>
			{createdAt && createdAt !== "" ? moment(createdAt).format("LLL") : "-"}
		</Typography>
	);
}
